/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import { Entity } from "@backstage/catalog-model";

export const CONFLUENCE_QUERY_ANNOTATION = "confluence/query";
export const CONFLUENCE_LIMIT_ANNOTATION = "confluence/limit";
export const CONFLUENCE_USER_ID_ANNOTATION = "confluence/user-id";

export const useProjectEntity = (entity: Entity) => {
  return {
    query: entity.metadata?.annotations?.[
      CONFLUENCE_QUERY_ANNOTATION
    ] as string,
    limit: entity.metadata?.annotations?.[
      CONFLUENCE_LIMIT_ANNOTATION
    ] as string,
    userId: entity.metadata?.annotations?.[
      CONFLUENCE_USER_ID_ANNOTATION
    ] as string,
  };
};
